module.exports = __webpack_public_path__ + "img/flag-no.1b6d1595.png";